/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Question12({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="12"
      role="img"
      viewBox="0 0 12 12"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.12 4.895C4.135 3.71 4.875 3 6.095 3c1.02 0 1.785.67 1.785 1.555 0 .765-.375 1.08-.825 1.385a2.25 2.25 0 0 1-.09.062 2.668 2.668 0 0 0-.065.043l-.015.01c-.307.205-.51.34-.51.625v.095H5.4V6.62c0-.585.33-.845.765-1.125l.055-.035c.355-.24.635-.43.635-.85 0-.145-.06-.625-.78-.625-.595 0-.9.33-.94 1l-.005.08-1.01-.1v-.07ZM6.53 7.65H5.32v1.175h1.21V7.65Z"
        fill={CssVars.textColor}
      />
      <path
        clipRule="evenodd"
        d="M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0Zm-1 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
        fill={CssVars.textColor}
        fillRule="evenodd"
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
